"use client";

import { Orbit } from "lucide-react";
import { useTranslations } from "next-intl";

import { AppLink } from "@/components/app-link";
import CurrencyFlag from "@/components/currency-flag";
import { Route } from "@/enums/route";

interface WelcomeEmptyStateProps {
  currency?: string;
}

export default function WelcomeEmptyState({
  currency,
}: WelcomeEmptyStateProps) {
  const t = useTranslations("welcomeEmpty");

  const title = currency ? t("titleWithCurrency", { currency }) : t("title");

  return (
    <div className="flex flex-col items-center text-center px-4 py-10 gap-3">
      {currency ? (
        <div className="flex items-center justify-center rounded-full bg-brand-primary/10 size-14 overflow-hidden">
          <CurrencyFlag
            currency={currency}
            size="44px"
            className="opacity-80"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center rounded-full bg-brand-primary/10 size-14">
          <Orbit className="size-7 text-brand-boundary" />
        </div>
      )}
      <h3 className="text-lg font-semibold text-gray-900">
        <span>{title}</span>
      </h3>
      <p className="text-sm text-gray-700 max-w-md">
        <span>{t("body")}</span>
      </p>
      <div className="flex gap-1 flex-wrap justify-center text-sm text-gray-700 mt-2">
        <span>{t("needHelp")}</span>
        <AppLink
          href={Route.Support}
          className="text-brand-strong hover:underline"
        >
          <span>{t("supportPageLink")}</span>
        </AppLink>
      </div>
    </div>
  );
}
